import { render, staticRenderFns } from "./SuccessPopup.vue?vue&type=template&id=22ca7b1f&scoped=true"
import script from "./SuccessPopup.vue?vue&type=script&lang=js"
export * from "./SuccessPopup.vue?vue&type=script&lang=js"
import style0 from "./SuccessPopup.vue?vue&type=style&index=0&id=22ca7b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca7b1f",
  null
  
)

export default component.exports